import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DCSummaryBlock slots="heading, buttons" theme="lightest" buttonPositionRight className="heading-align" mdxType="DCSummaryBlock" />
    <h3 {...{
      "id": "key-features-of-adobe-pdf-extract-api"
    }}>{`Key features of Adobe PDF Extract API`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-extract-api"
        }}>{`Start for free`}</a></li>
    </ul>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/2ee93c3577aa6b40a36a1ced79cb3e3f/comprehensive-content-extraction.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "comprehensive-content-extraction"
    }}>{`Comprehensive content extraction`}</h3>
    <p>{`Extract all PDF document elements including text, tables, and images within a structured JSON file to enable a variety of downstream solutions.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/5f6e6899ffe41cd806d8bae8a6b99130/document-structure-understanding.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "document-structure-understanding"
    }}>{`Document structure understanding`}</h3>
    <p>{`Classify text objects such as headings, lists, footnotes, and paragraphs that may span multiple columns or pages. Capture text fonts and styles, positioning, and the natural reading order of all objects.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/b08e0940f1397958c4909789b13f00d4/high-fidelity.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "highly-accurate-results"
    }}>{`Highly accurate results`}</h3>
    <p>{`Adobe Sensei AI technology delivers highly accurate data extraction across a broad range of document types – both native and scanned PDFs – without requiring custom ML templates or model training.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size padding-top-zero horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/3973377a9d677cf521ff4cd6052865b4/platform-agnostic.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "platform-agnostic"
    }}>{`Platform agnostic`}</h3>
    <p>{`Adobe’s PDF Extract API is RESTful and can be used to seamlessly integrate with any cloud platform or on-premise application.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      